import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from "react-bootstrap";
import SolutionArticleSummaryCard from "./SolutionArticleSummaryCard";
import "./SolutionArticleSummary.scss";

export default function SolutionArticleSummary(props) {

  const {title, items } = props.data;

  return (
    <div className={`article-summary-container lightBackground`}>
      <Col>
        <Row className="section-title">
          <h2>{title}</h2>
        </Row>
        <Row className="section-content-container">
          <div className="section-content px-0">
            {items.map((item, index) => <SolutionArticleSummaryCard key={index} data={item} scrollToElement={props.scrollToElement}/>)}
          </div>
        </Row>
      </Col>
    </div>
  )
}

SolutionArticleSummary.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.array,
  }),
  scrollToElement: PropTypes.func,
}
